import * as Unicons from '@iconscout/react-unicons';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import '../../global.css';
import './style.css';
import { jsx } from '@emotion/react';

interface TInputs {
  title?: string;
  subtitle?: string;
  textButton1?: string;
  textButton2?: string;
  styleButton1?: string;
  styleButton2?: string;
  link1?: string;
  link2?: string;
  open?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setShowAprovacaoModal?: (boo: boolean) => void;
  aproved: boolean;
}

const ModalCreate: React.FunctionComponent<TInputs> = ({
  open,
  title,
  textButton2,
  styleButton2,
  link2,
  subtitle,
  setShowAprovacaoModal,
  aproved,
}: TInputs) => {
  if (!open) return null;

  return (
    <div className="modalContainer">
      <div className="modalBox">
        <div className="circle-check">
          {aproved ? (
            <Unicons.UilCheck size="100" color="#1EBE5E" />
          ) : (
            <Unicons.UilTimes size="100" color="#FF0000" />
          )}
        </div>
        <h3>{title}</h3>
        <h6>{subtitle}</h6>
        <div className="line"></div>
        <div className="botoes">
          {aproved ? (
            <Link to={link2}>
              <Button
                id="button2"
                onClick={() => setShowAprovacaoModal && setShowAprovacaoModal(false)}
                className={styleButton2}
                style={{ marginLeft: 8, minWidth: 145 }}
              >
                {textButton2} 
              </Button>
            </Link>
          ) : (
            <Button
              id="button2"
              onClick={() => setShowAprovacaoModal && setShowAprovacaoModal(false)}
              className={styleButton2}
              style={{ marginLeft: 8, minWidth: 145 }}
            >
              {textButton2} 
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalCreate;
